/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './paramedic-referral-payment.reducer';

export const ParamedicReferralPayment = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const paramedicReferralPaymentList = useAppSelector(state => state.paramedicReferralPayment.entities);
  const loading = useAppSelector(state => state.paramedicReferralPayment.loading);
  const totalItems = useAppSelector(state => state.paramedicReferralPayment.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="paramedic-referral-payment-heading" data-cy="ParamedicReferralPaymentHeading">
        <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.home.title">Paramedic Referral Payments</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/paramedic-referral-payment/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.home.createLabel">
              Create new Paramedic Referral Payment
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.paramedicReferralPayment.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {paramedicReferralPaymentList && paramedicReferralPaymentList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('payment')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.payment">Payment</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('payment')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('referralChargeType')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.referralChargeType">Referral Charge Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referralChargeType')} />
                </th>
                <th className="hand" onClick={sort('addedByType')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.addedByType">Added By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByType')} />
                </th>
                <th className="hand" onClick={sort('addedByID')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.addedByID">Added By ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('addedByID')} />
                </th>
                <th className="hand" onClick={sort('modifiedByType')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.modifiedByType">Modified By Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByType')} />
                </th>
                <th className="hand" onClick={sort('modifiedByID')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.modifiedByID">Modified By ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('modifiedByID')} />
                </th>
                <th className="hand" onClick={sort('emergencyHike')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.emergencyHike">Emergency Hike</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('emergencyHike')} />
                </th>
                <th className="hand" onClick={sort('hishRiskHike')}>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.hishRiskHike">Hish Risk Hike</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('hishRiskHike')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.doctor">Doctor</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.hospital">Hospital</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.scheme">Scheme</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.paramedic">Paramedic</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {paramedicReferralPaymentList.map((paramedicReferralPayment, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/paramedic-referral-payment/${paramedicReferralPayment.id}`} color="link" size="sm">
                      {paramedicReferralPayment.id}
                    </Button>
                  </td>
                  <td>{paramedicReferralPayment.payment}</td>
                  <td>{paramedicReferralPayment.active ? 'true' : 'false'}</td>
                  <td>{paramedicReferralPayment.cursor}</td>
                  <td>{paramedicReferralPayment.microSec}</td>
                  <td>{paramedicReferralPayment.lastUpdated}</td>
                  <td>{paramedicReferralPayment.timestampEntry}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ReferralChargeType.${paramedicReferralPayment.referralChargeType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${paramedicReferralPayment.addedByType}`} />
                  </td>
                  <td>{paramedicReferralPayment.addedByID}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.AddedByType.${paramedicReferralPayment.modifiedByType}`} />
                  </td>
                  <td>{paramedicReferralPayment.modifiedByID}</td>
                  <td>{paramedicReferralPayment.emergencyHike}</td>
                  <td>{paramedicReferralPayment.hishRiskHike}</td>
                  <td>
                    {paramedicReferralPayment.doctor ? (
                      <Link to={`/doctor/${paramedicReferralPayment.doctor.id}`}>{paramedicReferralPayment.doctor.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {paramedicReferralPayment.hospital ? (
                      <Link to={`/hospital/${paramedicReferralPayment.hospital.id}`}>{paramedicReferralPayment.hospital.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {paramedicReferralPayment.scheme ? (
                      <Link to={`/payment-scheme/${paramedicReferralPayment.scheme.id}`}>{paramedicReferralPayment.scheme.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {paramedicReferralPayment.paramedic ? (
                      <Link to={`/paramedic/${paramedicReferralPayment.paramedic.id}`}>{paramedicReferralPayment.paramedic.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/paramedic-referral-payment/${paramedicReferralPayment.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/paramedic-referral-payment/${paramedicReferralPayment.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/paramedic-referral-payment/${paramedicReferralPayment.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.paramedicReferralPayment.home.notFound">
                No Paramedic Referral Payments found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={paramedicReferralPaymentList && paramedicReferralPaymentList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default ParamedicReferralPayment;
